import { useContext, useEffect, useState } from "react";

import { Dialog } from "@mui/material";
import MoveOrdersWidget from "../../components/MoveOrdersWidget";
import { useMoveTableOrdersData } from "../../shared/hooks/useTableOrdersData";

export default function MoveOrdersDialog({
    isOpen,
    selectedTable,
    targetTable,
    onClose,
}) {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [sourceTable, setSourceTable] = useState(null);
    const [distTable, setDistTable] = useState(null);

    const moveTableOrdersMutation = useMoveTableOrdersData();

    const onConfirm = (orderNames) => {
        if (
            orderNames &&
            orderNames.length > 0 &&
            sourceTable &&
            sourceTable.name &&
            distTable &&
            distTable.name
        ) {
            // Just open the dialog.
            moveTableOrdersMutation.mutate(
                {
                    orders: orderNames,
                    destTable: distTable.name,
                },
                {
                    onSettled: (data) => {
                        handleClose();
                    },
                }
            );
        }
    };

    useEffect(() => {
        if (selectedTable && targetTable) {
            setSourceTable(selectedTable);
            setDistTable(targetTable);
            setDialogOpen(true);
        } else {
            setSourceTable(null);
            setDistTable(null);
            setDialogOpen(false);
        }
    }, [selectedTable, targetTable]);

    const handleClose = () => {
        if (onClose) {
            onClose();
        }

        setSourceTable(null);
        setDistTable(null);

        const distSelectedEvent = new CustomEvent("ordersMoveTableClose");
        document.dispatchEvent(distSelectedEvent);

        setDialogOpen(false);
    };

    function renderMoveOrdersWidget() {
        return (
            <Dialog open={dialogOpen} onClose={handleClose}>
                <MoveOrdersWidget
                    sourceTable={sourceTable}
                    distTable={distTable}
                    onConfirm={onConfirm}
                    onClose={onClose}
                ></MoveOrdersWidget>
            </Dialog>
        );
    }

    return <>{dialogOpen && renderMoveOrdersWidget()}</>;
}
